import { ProcedureInstanceBase, ProcedureInstanceBaseParams } from './procedureInstanceBase';

export class ProcedureRun extends ProcedureInstanceBase {
  constructor(params: ProcedureInstanceBaseParams) {
    super(params);
  }
}
